import React from 'react';

// StepBuyer — the purchaser's details. The buyer signs in before this step, so
// when `locked` their name/email come from the account (read-only); we only
// edit them in the signed-out fallback. Their email gets the receipt, and the
// gift card itself when buying for self.
const StepBuyer = ({ value, onChange, locked = false }) => {
  if (locked) {
    return (
      <section className="gcs-step">
        <h2 className="gcs-step-title">Your details</h2>
        <div className="gcs-buyer-account">
          <span className="gcs-buyer-account-name">{value.buyerName || 'Your account'}</span>
          {value.buyerEmail && <span className="gcs-buyer-account-email">{value.buyerEmail}</span>}
          <span className="gcs-field-hint">
            Signed in — we will email your receipt here{value.giftMode === 'self' ? ' with the gift card' : ''}.
          </span>
        </div>
      </section>
    );
  }

  return (
    <section className="gcs-step">
      <h2 className="gcs-step-title">Your details</h2>
      <div className="gcs-fields">
        <label className="gcs-field">
          <span className="gcs-field-label">Your name</span>
          <input type="text" value={value.buyerName} placeholder="Full name"
            onChange={(e) => onChange({ buyerName: e.target.value })} />
        </label>
        <label className="gcs-field">
          <span className="gcs-field-label">Your email</span>
          <input type="email" value={value.buyerEmail} placeholder="you@example.com"
            onChange={(e) => onChange({ buyerEmail: e.target.value })} />
          <span className="gcs-field-hint">
            We will email your receipt here{value.giftMode === 'self' ? ' with the gift card' : ''}.
          </span>
        </label>
      </div>
    </section>
  );
};

export default StepBuyer;
